
import React, {
  PropTypes
} from 'react';

const SocialMedia = ({ socialMedia }) => (
  <a
    href={socialMedia.href}
    title={socialMedia.title}
    target="_blank"
    className="btn btn-default btn-lg"
  >
    <i className={ `fa fa-${socialMedia.icon} fa-fw` } />
  </a>
);

SocialMedia.propTypes = {
  socialMedia: PropTypes.shape().isRequired
};

export default SocialMedia;



// WEBPACK FOOTER //
// ./src/components/intro/SocialMedia.js